import Account from './Account'
import AccountDependencies from './AccountDependencies'

export default new Account(AccountDependencies)
